import {onMosReportListener} from '../../api/SessionListeners/onMosReport';

const mosReport = (quality) => {
	onMosReportListener(quality);
};

export default mosReport;